import { create } from "zustand";
import type { DietSearchResultsItemType } from "@/features/diets/types/diet-search-resilts.type";
import type { MultidietResponseType } from "../types/multidiet.type";

type Store = {
  multidiet: MultidietResponseType | null;
  diets: { day: string; diet: DietSearchResultsItemType }[];
  reloading: boolean;
  deliveryDate: Date[] | null;
  isCustomDeliveryDate: boolean;
};

type Actions = {
  setMultidiet: (multidiet: MultidietResponseType | null) => void;
  setMultidietDiets: ({
    day,
    diet,
  }: {
    day: string;
    diet: DietSearchResultsItemType;
  }) => void;
  setReloading: (reloading: boolean) => void;
  setDeliveryDate: (deliveryDate: Date[] | null) => void;
  setIsCustomDeliveryDate: (isCustomDeliveryDate: boolean) => void;
};

const initialState: Store = {
  multidiet: null,
  diets: [],
  reloading: false,
  deliveryDate: null,
  isCustomDeliveryDate: false,
};

const useMultidietStore = create<Store & Actions>()((set) => ({
  ...initialState,
  setMultidiet: (multidiet) =>
    set((state) => {
      if (!multidiet) {
        return { multidiet: null, diets: [] };
      }

      return {
        multidiet,
        diets: state.diets.filter((item) => item.day in multidiet.days),
      };
    }),
  setMultidietDiets: ({ day, diet }) =>
    set((state) => ({
      diets: state.diets.some((item) => item.day === day)
        ? state.diets.map((item) =>
            item.day === day ? { ...item, diet } : item,
          )
        : [...state.diets, { day, diet }],
    })),
  setReloading: (reloading) => set({ reloading }),
  setDeliveryDate: (deliveryDate) =>
    set({
      deliveryDate:
        deliveryDate?.sort((a, b) => a.getTime() - b.getTime()) || null,
    }),
  setIsCustomDeliveryDate: (isCustomDeliveryDate) =>
    set({ isCustomDeliveryDate }),
}));

export default useMultidietStore;
